import ComparisonChip from "../UI/chips/ComparisonChip";

const KpiComparisonTimePreference = ({
  total,
  percentComplied,
  compareTotal,
  comparePercentComplied,
  variant,
}: {
  total: number;
  percentComplied: number;
  compareTotal: number;
  comparePercentComplied: number;
  variant?: "chip" | "icon";
}) => {
  const value = total > 0 ? percentComplied : 100;
  const compareValue = compareTotal > 0 ? comparePercentComplied : 100;

  return (
    <ComparisonChip
      positiveIndicator="POSITIVE"
      value={value - compareValue}
      id={comparePercentComplied}
      unit="%"
      variant={variant}
    />
  );
};

export default KpiComparisonTimePreference;
